import { useState } from 'react';
import MainScreen from './screens/MainScreen';
import AccessScreen from './screens/AccessScreen';
import { grantAccess, isAccessGranted } from './utils/accessCode';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(isAccessGranted);

  const handleAccessSuccess = () => {
    grantAccess();
    setIsAuthenticated(true);
  };

  return (
    <div className="App">
      {isAuthenticated ? (
        <MainScreen />
      ) : (
        <AccessScreen onSuccess={handleAccessSuccess} />
      )}
    </div>
  );
}

export default App;
